module.exports = __webpack_public_path__ + "fonts/bf2d078.woff";